<div [formGroup]="form">
    <div class="row mb-3">
        <div class="col-xl-4 col-lg-5 col-5">
            <mat-label class="card-title text-dark mt-4 mb-4 font-14 font-400 labelpbutton">
                <!-- Method -->
                {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.METHOD' | transloco }}
            </mat-label>
        </div>

        <div class="col-xl-8 col-lg-7 col-7 method-select-btn">
            <!-- <form [formGroup]="StateFormGroup"> -->
            <div class="btn-group custom-toggle-wrap" role="group">
                <label *ngFor="let opt of stateOptions" class="btn custom-toggle" [class.active]="opt.value === form.get('calcMethod')?.value">
                    <input type="radio" class="btn-check" [value]="opt.value" [formControl]="form.get('calcMethod')" autocomplete="off" />
                    {{ opt.label }}
                </label>
            </div>
        </div>
    </div>
</div>
